module.exports = __webpack_public_path__ + "static/media/Mentorship-10.5a2bce9b.jpg";